import Rest from '../Rest'

export default class ProductService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/products'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  deleteFile(parentId, mediaId) {
    return this.delete(`/${parentId}/files/${mediaId}`).then(
      (response) => {
        return response
      }
    )
  }

  getItems(productId: Number) {
    return this.get(`/${productId}/items`).then(data => {
      return data
    })
  }

  getAvailableItems(productId: Number, type: String) {
    return this.get(`/${productId}/items/available`, { type }).then(data => {
      return data
    })
  }

  getProductItemTypes() {
    return this.get('/items/types').then(data => {
      return data
    })
  }

  /**
   * Mapa item→produto do escopo do usuário: para cada aula/plano/espaço do tipo,
   * o produto que o vende (id, nome, preço, status). Uma chamada por listagem
   * (coluna "Venda") ou por item (retomar o passo a passo de venda).
   */
  getItemsMap(type: String, modelId: any = null) {
    const params: any = { type }
    if (modelId !== null && modelId !== undefined) {
      params.model_id = modelId
    }
    return this.get('/items/map', params)
  }

  /**
   * Anúncio do item, criado sob demanda pelo servidor de forma idempetente.
   *
   * Substitui o par create-produto + vincular-item que a tela fazia sozinha:
   * duas chamadas decididas aqui a partir de uma leitura anterior duplicavam o
   * anúncio quando a leitura ainda estava em voo, e o anúncio com preço e fotos
   * virava órfão. Devolve o payload completo (igual ao GET /products/{id}).
   */
  ensureItemProduct(type: String, modelId: any, name: any = null) {
    const form: any = { type, model_id: Number(modelId) }
    if (name) {
      form.name = name
    }
    return this.post('/items/ensure', { form })
  }

  addProductItem(productId: Number, data: any) {
    return this.post(`${productId}/items`, data).then(
      (data) => {
        return data
      }
    )
  }

  deleteProductItem(productId, productItemId) {
    return this.delete(`/${productId}/items/${productItemId}`).then(
      (response) => {
        return response
      }
    )
  }

  getProductToSalesGrid(path: string = '', data: any) {
    return this.grid('/sales/grid', data)
  }

  /** Posição na vitrine "Em alta" da Home do marketplace. null remove o destaque. */
  setFeaturedOrder(productId: Number, featuredOrder: Number | null) {
    return this.put(`/${productId}/featured`, { featured_order: featuredOrder }).then(
      (response) => {
        return response
      }
    )
  }
}
